import { useInternationalization } from '../../hooks';
import { Dashboard } from './Dashboard';

export const DashboardVendor = () => {
  const { t } = useInternationalization();
  return <Dashboard title={t('navigation:sections.home')} />;
};
